
<div>
  <b-row>
    <SelectField
      v-if="meta && !meta.product"
      v-model="productId"
      class="col-12"
      :label="__('common.product')"
      name="product_id"
      :options="products"
      @onChange="productSelected"
    />

    <TextField
      v-model="commission"
      class="col-4"
      name="commission"
      :label="__('common.agent-commission') + ', %'"
      type="number"
    />
    <TextField
      v-model="grossAmount"
      class="col-4"
      name="gross_amount"
      :label="__('common.gross-commission')"
      type="number"
    />
    <TextField
      v-model="feeAmount"
      class="col-4"
      name="fee_amount"
      :label="__('entities.fee')"
      type="number"
    />
    <DateField
      v-if="isEntityProductHistoryEnabled"
      v-model="activeFrom"
      class="col-4"
      name="active_from"
      :label="__('entities.active-from')"
    />
  </b-row>

  <div class="text-right">
    <b-button size="sm" variant="primary" @click="submit">
      <Icon icon="save" size="14" class="mr-2" />
      {{ __('buttons.save') }}
    </b-button>
  </div>
</div>
